import Country from "../Country/Country";
import { ContainerComponent, ShowNotification, ResponsiveRow } from "./style";
import { useEffect, useState } from "react";
import countryDataJson from "../../asset/data.json";
import { Col } from "antd";
import { useMediaQuery } from "react-responsive";

const Content = ({ selectedRegion, searchTerm, isDarkMode }) => {
  const [countryData, setCountryData] = useState([]);
  const [filteredCountries, setFilteredCountries] = useState([]);
  const [loading, setLoading] = useState(true);

  const is1200 = useMediaQuery({ query: "(max-width: 1200px)" });
  const is960 = useMediaQuery({ query: "(max-width: 960px)" });
  const is550 = useMediaQuery({ query: "(max-width: 550px)" });

  const getGutter = () => {
    if (is960) return [20, 20];
    if (is1200) return [40, 40];
    return [60, 60];
  };

  const getColumnProps = () => {
    if (is550) return { xs: 24 };
    if (is960) return { xs: 12 };
    if (is1200) return { xs: 8 };
    return { xs: 6 };
  };

  useEffect(() => {
    const fetchCountryData = () => {
      try {
        setLoading(true);
        const countries = countryDataJson.map((country) => ({
          flagUrl: country.flags.png,
          countryName: country.name,
          population: country.population,
          region: country.region,
          capital: country.capital || "N/A",
        }));
        countries.sort((a, b) => a.countryName.localeCompare(b.countryName));

        setCountryData(countries);
        setFilteredCountries(countries);
      } catch (error) {
        console.error("Error loading country data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCountryData();
  }, []);

  useEffect(() => {
    let filtered = countryData;
    if (selectedRegion !== "") {
      filtered = filtered.filter(
        (country) => country.region === selectedRegion
      );
    }
    if (searchTerm !== "") {
      filtered = filtered.filter((country) =>
        country.countryName.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    setFilteredCountries(filtered);
  }, [selectedRegion, countryData, searchTerm]);

  if (loading) {
    return (
      <ShowNotification isDarkMode={isDarkMode}>
        <h3>Loading...</h3>
      </ShowNotification>
    );
  }

  return (
    <>
      <ContainerComponent isDarkMode={isDarkMode}>
        <ResponsiveRow gutter={getGutter()} justify="start">
          {filteredCountries.length > 0 ? (
            filteredCountries.map((country, index) => (
              <Col {...getColumnProps()} key={index}>
                <Country
                  isDarkMode={isDarkMode}
                  flagUrl={country.flagUrl}
                  countryName={country.countryName}
                  population={country.population}
                  region={country.region}
                  capital={country.capital}
                />
              </Col>
            ))
          ) : (
            <ShowNotification isDarkMode={isDarkMode}>
              <span>No results found</span>
            </ShowNotification>
          )}
        </ResponsiveRow>
      </ContainerComponent>
    </>
  );
};

export default Content;
